// extracted by mini-css-extract-plugin
module.exports = {"RefreshContainer":"AssessmentsGuide_RefreshContainer__3RqIZ","RefreshIcon":"AssessmentsGuide_RefreshIcon__X1KB2"};